import React from "react";
import PropTypes from "prop-types";

// styles
import { OverviewStyled, TempTitleDescPlaceholderStyled } from "./styles.js";

// components
import SideBarSection from "../SideBarSection";
import SelectedBatchPhotoId from "./SelectedBatchPhotoId";
import TitleDescription from "./TitleDescription/index.js";
import ReasonsForDenial from "./ReasonsForDenial";
import Location from "./Location";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

const TempPlaceHolderTitleAndDescription = ({ singleUploadSelected }) => {
    if (!singleUploadSelected) return null;

    const { title, description } = singleUploadSelected;

    return (
        <>
            <TempTitleDescPlaceholderStyled>
                {title || <i>Title Empty</i>}
            </TempTitleDescPlaceholderStyled>
            <TempTitleDescPlaceholderStyled>
                {description || <i>Description Empty</i>}
            </TempTitleDescPlaceholderStyled>
        </>
    );
};

export const Overview = ({
    children,
    title = "Overview",
    onSaveTitle,
    onToggleApproveTitle,
    onSaveDescription,
    onToggleApproveDescription,
    onLocationUpdate
}) => {
    // state/context
    const queueContext = useQueueContext();

    const {
        uploadTypeTitle,
        selectedBatch,
        ovewrviewIsEditable,
        state: { singleUploadSelected }
    } = queueContext;

    return (
        <SideBarSection title={title}>
            <OverviewStyled>
                <div>
                    <SelectedBatchPhotoId title="Batch" id={selectedBatch.id} />
                    {singleUploadSelected && (
                        <SelectedBatchPhotoId
                            title={uploadTypeTitle}
                            id={singleUploadSelected.id}
                        />
                    )}
                </div>
                {ovewrviewIsEditable ? (
                    <TitleDescription
                        singleUploadSelected={singleUploadSelected}
                        onSaveTitle={onSaveTitle}
                        onToggleApproveTitle={onToggleApproveTitle}
                        onSaveDescription={onSaveDescription}
                        onToggleApproveDescription={onToggleApproveDescription}
                    />
                ) : (
                    <TempPlaceHolderTitleAndDescription
                        singleUploadSelected={singleUploadSelected}
                    />
                )}
                <Location
                    singleUploadSelected={singleUploadSelected}
                    onLocationUpdate={onLocationUpdate}
                />
                <ReasonsForDenial singleUploadSelected={singleUploadSelected} />
                {children}
            </OverviewStyled>
        </SideBarSection>
    );
};

export default Overview;

// prop-types
Overview.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    onSaveTitle: PropTypes.func.isRequired,
    onToggleApproveTitle: PropTypes.func.isRequired,
    onSaveDescription: PropTypes.func.isRequired,
    onToggleApproveDescription: PropTypes.func.isRequired,
    onLocationUpdate: PropTypes.func.isRequired
};
